import { render, staticRenderFns } from "./results.vue?vue&type=template&id=b1f2ca76&scoped=true&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&id=b1f2ca76&prod&lang=scss&scoped=true&"
import style1 from "./results.vue?vue&type=style&index=1&id=b1f2ca76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2ca76",
  null
  
)

export default component.exports